import { KnowledgeExtractionLog } from '@/types/knowledge';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { FileText, CheckCircle, AlertCircle, Clock } from 'lucide-react';

interface MetricsDashboardProps {
  logs: KnowledgeExtractionLog[];
}

export function MetricsDashboard({ logs }: MetricsDashboardProps) {
  const totalTickets = logs.reduce((sum, log) => sum + log.ticketsProcessed, 0);
  const totalDocsCreated = logs.reduce((sum, log) => sum + log.documentsCreated, 0);
  const totalDocsUpdated = logs.reduce((sum, log) => sum + log.documentsUpdated, 0);
  const totalErrors = logs.reduce((sum, log) => sum + log.errorsCount, 0);
  const errorRate = totalTickets > 0 ? (totalErrors / totalTickets) * 100 : 0;
  const avgDuration = logs.length > 0
    ? logs.reduce((sum, log) => sum + log.durationMs, 0) / logs.length / 1000
    : 0;

  const metrics = [
    {
      title: 'Total de Tickets',
      value: totalTickets,
      icon: FileText,
      color: 'text-blue-500',
    },
    {
      title: 'Documentos Criados',
      value: totalDocsCreated,
      icon: CheckCircle,
      color: 'text-green-500',
    },
    {
      title: 'Documentos Atualizados',
      value: totalDocsUpdated,
      icon: CheckCircle,
      color: 'text-yellow-500',
    },
    {
      title: 'Taxa de Erro',
      value: `${errorRate.toFixed(1)}%`,
      icon: AlertCircle,
      color: errorRate > 5 ? 'text-red-500' : 'text-green-500',
    },
    {
      title: 'Tempo Médio',
      value: `${avgDuration.toFixed(2)}s`,
      icon: Clock,
      color: 'text-purple-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card key={metric.title}>
            <CardHeader className="flex flex-row items-center justify-between pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {metric.title}
              </CardTitle>
              <Icon className={`h-4 w-4 ${metric.color}`} />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{metric.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
